// Studyo Today Users
// Package studyo.today.users.v1
// Service definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/users/v1/users.proto (package studyo.today.users.v1, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_google_type_date } from "@buf/googleapis_googleapis.bufbuild_es/google/type/date_pb.js";
import { file_studyo_today_users_v1_resources_identity } from "./resources/identity_pb.js";
import { file_studyo_today_users_v1_resources_platform } from "./resources/platform_pb.js";
import { file_studyo_today_users_v1_resources_preference_value } from "./resources/preference_value_pb.js";
import { file_studyo_today_users_v1_resources_today_user } from "./resources/today_user_pb.js";
import { file_studyo_today_users_v1_resources_user_persona } from "./resources/user_persona_pb.js";
import { file_studyo_today_users_v1_resources_user_profile } from "./resources/user_profile_pb.js";

/**
 * Describes the file studyo/today/users/v1/users.proto.
 */
export const file_studyo_today_users_v1_users = /*@__PURE__*/
  fileDesc("CiFzdHVkeW8vdG9kYXkvdXNlcnMvdjEvdXNlcnMucHJvdG8SFXN0dWR5by50b2RheS51c2Vycy52MSIoChRCYXRjaEdldFVzZXJzUmVxdWVzdBIQCgh1c2VyX2lkcxgBIAMoCSJSChVCYXRjaEdldFVzZXJzUmVzcG9uc2USOQoFdXNlcnMYASADKAsyKi5zdHVkeW8udG9kYXkudXNlcnMudjEucmVzb3VyY2VzLlRvZGF5VXNlciI0ChxTZXRDdXJyZW50VXNlckN1bHR1cmVSZXF1ZXN0EhQKDGN1bHR1cmVfbmFtZRgBIAEoCSI0ChtHZXRJbnRlcmNvbVVzZXJIYXNoUmVzcG9uc2USEQoJdXNlcl9oYXNoGAEgASgJOgIYASJhCiJHZXRQbGF0Zm9ybUludGVyY29tVXNlckhhc2hSZXF1ZXN0EjsKCHBsYXRmb3JtGAEgASgOMikuc3R1ZHlvLnRvZGF5LnVzZXJzLnYxLnJlc291cmNlcy5QbGF0Zm9ybSI4CiNHZXRQbGF0Zm9ybUludGVyY29tVXNlckhhc2hSZXNwb25zZRIRCgl1c2VyX2hhc2gYASABKAkieAobR2V0VXNlckRhaWx5QWN0aXZpdHlSZXF1ZXN0Eg8KB3VzZXJfaWQYASABKAkSIwoIbWluX2RhdGUYAiABKAsyES5nb29nbGUudHlwZS5EYXRlEiMKCG1heF9kYXRlGAMgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZSJQChxHZXRVc2VyRGFpbHlBY3Rpdml0eVJlc3BvbnNlEiAKBWRhdGVzGAEgAygLMhEuZ29vZ2xlLnR5cGUuRGF0ZRIOCgZ2YWx1ZXMYAiADKAUiOgomQ3JlYXRlUHJvZmlsZVBpY3R1cmVEZXN0aW5hdGlvblJlcXVlc3QSEAoIZmlsZW5hbWUYASABKAkiUwonQ3JlYXRlUHJvZmlsZVBpY3R1cmVEZXN0aW5hdGlvblJlc3BvbnNlEhIKCnVwbG9hZF91cmwYASABKAkSFAoMZG93bmxvYWRfdXJsGAIgASgJIkUKG0N1c3RvbWl6ZUN1cnJlbnRVc2VyUmVxdWVzdBIRCglmdWxsX25hbWUYASABKAkSEwoLcGljdHVyZV91cmwYAiABKAkiMwogUGVybWFuZW50bHlEZWxldGVVc2VyRGF0YVJlcXVlc3QSDwoHdXNlcl9pZBgBIAEoCSIpChdGaW5kVXNlcnNCeUVtYWlsUmVxdWVzdBIOCgZlbWFpbHMYASADKAkiVQoYRmluZFVzZXJzQnlFbWFpbFJlc3BvbnNlEjkKBXVzZXJzGAEgAygLMiouc3R1ZHlvLnRvZGF5LnVzZXJzLnYxLnJlc291cmNlcy5Ub2RheVVzZXIiYQoQRmluZFVzZXJzUmVxdWVzdBIOCgZlbWFpbHMYASADKAkSPQoKaWRlbnRpdGllcxgCIAMoCzIpLnN0dWR5by50b2RheS51c2Vycy52MS5yZXNvdXJjZXMuSWRlbnRpdHkiTgoRRmluZFVzZXJzUmVzcG9uc2USOQoFdXNlcnMYASADKAsyKi5zdHVkeW8udG9kYXkudXNlcnMudjEucmVzb3VyY2VzLlRvZGF5VXNlciIoChVHZXRVc2VyUHJvZmlsZVJlcXVlc3QSDwoHdXNlcl9pZBgBIAEoCSJVChRBc3NpZ25QZXJzb25hUmVxdWVzdBI9CgdwZXJzb25hGAEgASgOMiwuc3R1ZHlvLnRvZGF5LnVzZXJzLnYxLnJlc291cmNlcy5Vc2VyUGVyc29uYSJkChRTZXRQcmVmZXJlbmNlUmVxdWVzdBILCgNrZXkYASABKAkSPwoFdmFsdWUYAiABKAsyMC5zdHVkeW8udG9kYXkudXNlcnMudjEucmVzb3VyY2VzLlByZWZlcmVuY2VWYWx1ZSIjChRHZXRQcmVmZXJlbmNlUmVxdWVzdBILCgNrZXkYASABKAkiWAoVR2V0UHJlZmVyZW5jZVJlc3BvbnNlEj8KBXZhbHVlGAIgASgLMjAuc3R1ZHlvLnRvZGF5LnVzZXJzLnYxLnJlc291cmNlcy5QcmVmZXJlbmNlVmFsdWUiVAofQ3JlYXRlRGVtb1NjaG9vbFNuYXBzaG90UmVxdWVzdBIRCglzY2hvb2xfaWQYASABKAkSDAoEbmFtZRgCIAEoCRIQCgh1c2VyX2lkcxgDIAMoCSJDCiBSZXN0b3JlRGVtb1NjaG9vbFNuYXBzaG90UmVxdWVzdBIRCglzY2hvb2xfaWQYASABKAkSDAoEbmFtZRgCIAEoCTLrEAoFVXNlcnMSVgoOR2V0Q3VycmVudFVzZXISFi5nb29nbGUucHJvdG9idWYuRW1wdHkaKi5zdHVkeW8udG9kYXkudXNlcnMudjEucmVzb3VyY2VzLlRvZGF5VXNlciIAEmwKDUJhdGNoR2V0VXNlcnMSKy5zdHVkeW8udG9kYXkudXNlcnMudjEuQmF0Y2hHZXRVc2Vyc1JlcXVlc3QaLC5zdHVkeW8udG9kYXkudXNlcnMudjEuQmF0Y2hHZXRVc2Vyc1Jlc3BvbnNlIgASegoVU2V0Q3VycmVudFVzZXJDdWx0dXJlEjMuc3R1ZHlvLnRvZGF5LnVzZXJzLnYxLlNldEN1cnJlbnRVc2VyQ3VsdHVyZVJlcXVlc3QaKi5zdHVkeW8udG9kYXkudXNlcnMudjEucmVzb3VyY2VzLlRvZGF5VXNlciIAEmYKE0dldEludGVyY29tVXNlckhhc2gSFi5nb29nbGUucHJvdG9idWYuRW1wdHkaMi5zdHVkeW8udG9kYXkudXNlcnMudjEuR2V0SW50ZXJjb21Vc2VySGFzaFJlc3BvbnNlIgOIAgESlgEKG0dldFBsYXRmb3JtSW50ZXJjb21Vc2VySGFzaBI5LnN0dWR5by50b2RheS51c2Vycy52MS5HZXRQbGF0Zm9ybUludGVyY29tVXNlckhhc2hSZXF1ZXN0Gjouc3R1ZHlvLnRvZGF5LnVzZXJzLnYxLkdldFBsYXRmb3JtSW50ZXJjb21Vc2VySGFzaFJlc3BvbnNlIgASgQEKFEdldFVzZXJEYWlseUFjdGl2aXR5EjIuc3R1ZHlvLnRvZGF5LnVzZXJzLnYxLkdldFVzZXJEYWlseUFjdGl2aXR5UmVxdWVzdBozLnN0dWR5by50b2RheS51c2Vycy52MS5HZXRVc2VyRGFpbHlBY3Rpdml0eVJlc3BvbnNlIgASogEKH0NyZWF0ZVByb2ZpbGVQaWN0dXJlRGVzdGluYXRpb24SPS5zdHVkeW8udG9kYXkudXNlcnMudjEuQ3JlYXRlUHJvZmlsZVBpY3R1cmVEZXN0aW5hdGlvblJlcXVlc3QaPi5zdHVkeW8udG9kYXkudXNlcnMudjEuQ3JlYXRlUHJvZmlsZVBpY3R1cmVEZXN0aW5hdGlvblJlc3BvbnNlIgASeAoUQ3VzdG9taXplQ3VycmVudFVzZXISMi5zdHVkeW8udG9kYXkudXNlcnMudjEuQ3VzdG9taXplQ3VycmVudFVzZXJSZXF1ZXN0Giouc3R1ZHlvLnRvZGF5LnVzZXJzLnYxLnJlc291cmNlcy5Ub2RheVVzZXIiABJuChlQZXJtYW5lbnRseURlbGV0ZVVzZXJEYXRhEjcuc3R1ZHlvLnRvZGF5LnVzZXJzLnYxLlBlcm1hbmVudGx5RGVsZXRlVXNlckRhdGFSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5IgASeAoQRmluZFVzZXJzQnlFbWFpbBIuLnN0dWR5by50b2RheS51c2Vycy52MS5GaW5kVXNlcnNCeUVtYWlsUmVxdWVzdBovLnN0dWR5by50b2RheS51c2Vycy52MS5GaW5kVXNlcnNCeUVtYWlsUmVzcG9uc2UiA4gCARJgCglGaW5kVXNlcnMSJy5zdHVkeW8udG9kYXkudXNlcnMudjEuRmluZFVzZXJzUmVxdWVzdBooLnN0dWR5by50b2RheS51c2Vycy52MS5GaW5kVXNlcnNSZXNwb25zZSIAEl8KFUdldEN1cnJlbnRVc2VyUHJvZmlsZRIWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRosLnN0dWR5by50b2RheS51c2Vycy52MS5yZXNvdXJjZXMuVXNlclByb2ZpbGUiABJuCg5HZXRVc2VyUHJvZmlsZRIsLnN0dWR5by50b2RheS51c2Vycy52MS5HZXRVc2VyUHJvZmlsZVJlcXVlc3QaLC5zdHVkeW8udG9kYXkudXNlcnMudjEucmVzb3VyY2VzLlVzZXJQcm9maWxlIgASbAoNQXNzaWduUGVyc29uYRIrLnN0dWR5by50b2RheS51c2Vycy52MS5Bc3NpZ25QZXJzb25hUmVxdWVzdBosLnN0dWR5by50b2RheS51c2Vycy52MS5yZXNvdXJjZXMuVXNlclByb2ZpbGUiABJNChlDb21wbGV0ZU9uYm9hcmRpbmdQcm9jZXNzEhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5IgASVgoNU2V0UHJlZmVyZW5jZRIrLnN0dWR5by50b2RheS51c2Vycy52MS5TZXRQcmVmZXJlbmNlUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eSIAEmwKDUdldFByZWZlcmVuY2USKy5zdHVkeW8udG9kYXkudXNlcnMudjEuR2V0UHJlZmVyZW5jZVJlcXVlc3QaLC5zdHVkeW8udG9kYXkudXNlcnMudjEuR2V0UHJlZmVyZW5jZVJlc3BvbnNlIgASbAoYQ3JlYXRlRGVtb1NjaG9vbFNuYXBzaG90EjYuc3R1ZHlvLnRvZGF5LnVzZXJzLnYxLkNyZWF0ZURlbW9TY2hvb2xTbmFwc2hvdFJlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHkiABJuChlSZXN0b3JlRGVtb1NjaG9vbFNuYXBzaG90Ejcuc3R1ZHlvLnRvZGF5LnVzZXJzLnYxLlJlc3RvcmVEZW1vU2Nob29sU25hcHNob3RSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5IgBCHaoCGlN0dWR5by5Ub2RheS5Vc2Vycy5HcnBjLlYxYgZwcm90bzM", [file_google_protobuf_empty, file_google_type_date, file_studyo_today_users_v1_resources_identity, file_studyo_today_users_v1_resources_platform, file_studyo_today_users_v1_resources_preference_value, file_studyo_today_users_v1_resources_today_user, file_studyo_today_users_v1_resources_user_persona, file_studyo_today_users_v1_resources_user_profile]);

/**
 * Describes the message studyo.today.users.v1.BatchGetUsersRequest.
 * Use `create(BatchGetUsersRequestSchema)` to create a new message.
 */
export const BatchGetUsersRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 0);

/**
 * Describes the message studyo.today.users.v1.BatchGetUsersResponse.
 * Use `create(BatchGetUsersResponseSchema)` to create a new message.
 */
export const BatchGetUsersResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 1);

/**
 * Describes the message studyo.today.users.v1.SetCurrentUserCultureRequest.
 * Use `create(SetCurrentUserCultureRequestSchema)` to create a new message.
 */
export const SetCurrentUserCultureRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 2);

/**
 * Describes the message studyo.today.users.v1.GetIntercomUserHashResponse.
 * Use `create(GetIntercomUserHashResponseSchema)` to create a new message.
 * @deprecated
 */
export const GetIntercomUserHashResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 3);

/**
 * Describes the message studyo.today.users.v1.GetPlatformIntercomUserHashRequest.
 * Use `create(GetPlatformIntercomUserHashRequestSchema)` to create a new message.
 */
export const GetPlatformIntercomUserHashRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 4);

/**
 * Describes the message studyo.today.users.v1.GetPlatformIntercomUserHashResponse.
 * Use `create(GetPlatformIntercomUserHashResponseSchema)` to create a new message.
 */
export const GetPlatformIntercomUserHashResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 5);

/**
 * Describes the message studyo.today.users.v1.GetUserDailyActivityRequest.
 * Use `create(GetUserDailyActivityRequestSchema)` to create a new message.
 */
export const GetUserDailyActivityRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 6);

/**
 * Describes the message studyo.today.users.v1.GetUserDailyActivityResponse.
 * Use `create(GetUserDailyActivityResponseSchema)` to create a new message.
 */
export const GetUserDailyActivityResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 7);

/**
 * Describes the message studyo.today.users.v1.CreateProfilePictureDestinationRequest.
 * Use `create(CreateProfilePictureDestinationRequestSchema)` to create a new message.
 */
export const CreateProfilePictureDestinationRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 8);

/**
 * Describes the message studyo.today.users.v1.CreateProfilePictureDestinationResponse.
 * Use `create(CreateProfilePictureDestinationResponseSchema)` to create a new message.
 */
export const CreateProfilePictureDestinationResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 9);

/**
 * Describes the message studyo.today.users.v1.CustomizeCurrentUserRequest.
 * Use `create(CustomizeCurrentUserRequestSchema)` to create a new message.
 */
export const CustomizeCurrentUserRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 10);

/**
 * Describes the message studyo.today.users.v1.PermanentlyDeleteUserDataRequest.
 * Use `create(PermanentlyDeleteUserDataRequestSchema)` to create a new message.
 */
export const PermanentlyDeleteUserDataRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 11);

/**
 * Describes the message studyo.today.users.v1.FindUsersByEmailRequest.
 * Use `create(FindUsersByEmailRequestSchema)` to create a new message.
 */
export const FindUsersByEmailRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 12);

/**
 * Describes the message studyo.today.users.v1.FindUsersByEmailResponse.
 * Use `create(FindUsersByEmailResponseSchema)` to create a new message.
 */
export const FindUsersByEmailResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 13);

/**
 * Describes the message studyo.today.users.v1.FindUsersRequest.
 * Use `create(FindUsersRequestSchema)` to create a new message.
 */
export const FindUsersRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 14);

/**
 * Describes the message studyo.today.users.v1.FindUsersResponse.
 * Use `create(FindUsersResponseSchema)` to create a new message.
 */
export const FindUsersResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 15);

/**
 * Describes the message studyo.today.users.v1.GetUserProfileRequest.
 * Use `create(GetUserProfileRequestSchema)` to create a new message.
 */
export const GetUserProfileRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 16);

/**
 * Describes the message studyo.today.users.v1.AssignPersonaRequest.
 * Use `create(AssignPersonaRequestSchema)` to create a new message.
 */
export const AssignPersonaRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 17);

/**
 * Describes the message studyo.today.users.v1.SetPreferenceRequest.
 * Use `create(SetPreferenceRequestSchema)` to create a new message.
 */
export const SetPreferenceRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 18);

/**
 * Describes the message studyo.today.users.v1.GetPreferenceRequest.
 * Use `create(GetPreferenceRequestSchema)` to create a new message.
 */
export const GetPreferenceRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 19);

/**
 * Describes the message studyo.today.users.v1.GetPreferenceResponse.
 * Use `create(GetPreferenceResponseSchema)` to create a new message.
 */
export const GetPreferenceResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 20);

/**
 * Describes the message studyo.today.users.v1.CreateDemoSchoolSnapshotRequest.
 * Use `create(CreateDemoSchoolSnapshotRequestSchema)` to create a new message.
 */
export const CreateDemoSchoolSnapshotRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 21);

/**
 * Describes the message studyo.today.users.v1.RestoreDemoSchoolSnapshotRequest.
 * Use `create(RestoreDemoSchoolSnapshotRequestSchema)` to create a new message.
 */
export const RestoreDemoSchoolSnapshotRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_users, 22);

/**
 * Service definition for the Today Users API.
 *
 * @generated from service studyo.today.users.v1.Users
 */
export const Users = /*@__PURE__*/
  serviceDesc(file_studyo_today_users_v1_users, 0);

